import React from "react";
import Summary from "./components/Summary";

const App = () => {
  return <Summary />;
};

export default App;
